<template>
  <div :class="['module_setting', $store.state.app.web_language_wm !== 'en' ? 'c-module_setting' : '']">
    <el-tabs v-model="activeName" @tab-click="change_tab">
      <el-tab-pane :label="$t('view_left_sidebar_btn_108')" name="module">
        <module></module>
      </el-tab-pane>
      <el-tab-pane :label="$t('view_left_sidebar_module_setting_276')" name="material">
        <material></material>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import i18n from '../../language/index'

import Module from './module/add_module'
import Material from './module/add_material'

export default {
  name: "left_sidebar_module_setting",
  components: {
    Module, Material
  },
  data() {
    return {
      activeName: 'module',
    }
  },
  watch: {
    '$store.state.left_sidebar.module_tab_active'(val) {
      this.activeName = val
    }
  },
  methods: {
    change_tab(tab) {
      this.$store.commit('left_sidebar/set_module_tab_active', tab.name)
      this.activeName = this.$store.state.left_sidebar.module_tab_active
    }
  }
}
</script>

<style lang="scss" scoped>
.module_setting {
  height: 100%;
  .el-tabs--top{
    height: 100%;
    overflow: hidden;
  }
  /deep/ .el-tabs__header {
    margin: 0;
    padding-left: 20px;
    height: 50px;
    background: #f5f5f5;

    .el-tabs__nav-wrap::after {
      background: transparent;
    }

    .el-tabs__active-bar {
      // width: 60px !important;
    }

    .el-tabs__item {
      height: 50px;
      padding: 0;
      padding-right: 20px;
      line-height: 50px;
      color: #999999;
      font-size: 14px;

      &.is-active {
        color: #0078d7;
        background: transparent;
      }
    }
  }

  /deep/ .el-tabs__content{
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0;
    height: calc(100% - 58px);
  }

  .tab_content {
    padding: 20px 30px;
    height: 630px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &.c-module_setting {
    /deep/ .el-tabs {
    .el-tabs__header {
      .el-tabs__active-bar {
          width: 60px !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/module_setting.vue